module.exports = __webpack_public_path__ + "media/volvo/assets/images/unlock-6e912ee8dd88475fc1c97aef25730fa9.png";